import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';
import { ExportModalComponent } from 'app/helpers/components/exportModal/exportModal.component';
import { ImportModalComponent } from 'app/helpers/components/importModal/importModal.component';
import { sxFileImportComponent } from 'app/helpers/components/sxFileImport/fileImport.component';

@Component({
    templateUrl: 'listado.resources.component.html',
    styleUrls: ['listado.resources.component.css'],
})

export class ListadoResourcesComponent implements OnInit {

  codOrganization: string;
  codSubscription: string;
  codChannel: string;
  //codProduct: string;

  isCustom: boolean = false;

  resources: any;
  wordTypes = [];

  pageSize = 100;
  pageNum: number = 1;
  maxSize: number = 5;
  totalRecords: number;

  filterCode: string;
  filterWordType: number = 0;

  jsonLink: string;
  
  constructor(
      private router: Router,
      private aRoute: ActivatedRoute,
      private modalService: NgbModal,
      private alertService: AlertService,
      private sxTranslationService: SxTranslationService) { }

  ngOnInit() {
    this.aRoute.data.subscribe((data: Params) => {
      if (data.isCustom) {
        this.isCustom = data.isCustom;        
      } else {
        this.sxTranslationService.getAllWordTypes()
        .then(response => {
          this.wordTypes = response.result;
        });
      }
    });

    this.aRoute.params.subscribe((params: Params) => {
      this.codOrganization = params['codorganizacion'];
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];
      //this.codProduct = params['codproducto'];

      this.fetchData(1);
    });
  }

  edit(element: any) {
    if (element.isCustom) {
      this.router.navigate(['editResource', element.id], { relativeTo: this.aRoute });
    } else {
      this.router.navigate(['viewResource', element.id], { relativeTo: this.aRoute });
    }    
  }

  delete(element: any) {
    const modalRef = this.modalService.open(ConfirmacionModalComponent);
    const modalInstance = <ConfirmacionModalComponent>modalRef.componentInstance;
    modalInstance.titulo = this.sxTranslationService.getResource('DISABLE_RESOURCE');

    modalRef.result.then(() => {
      this.sxTranslationService.deleteCustomVocabulary(element.id)
        .then(success => {
          if (success) {
            this.alertService.showGrowl({
                type: GrowlType.SUCCESS,
                body: 'RESOURCE_INTER_DELETED',
            });
          } else {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'RESOURCE_INTER_COULD_NOT_DELETE',
            });
          }
          
          this.fetchData(1);
        });     
    });
  }

  fetchData(page) {
    this.pageNum = page;
   
    let promise;

    if (this.isCustom) {
      promise = this.sxTranslationService.getCustomVocabularies(this.codOrganization, this.codSubscription, this.codChannel, this.pageNum, this.pageSize, this.filterCode);
    } else {
      promise = this.sxTranslationService.getSystemVocabularies(this.pageNum, this.pageSize, this.filterCode, this.filterWordType != 0 ? this.filterWordType : null);
    }

    promise.then(result => {
      this.totalRecords = result.count;
      this.resources = result.items;
    });
  }

  public back() {
    this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
  }

  export(){

    const modalRef = this.modalService.open(ExportModalComponent, {
      size: 'sm',
      windowClass: 'modal-xl',
    });

    const modalInstance = <ExportModalComponent>modalRef.componentInstance;

    modalInstance.isCustom = this.isCustom;
    modalInstance.codOrganization = this.codOrganization;
    modalInstance.codSuscription = this.codSubscription;
    modalInstance.codChannel = this.codChannel;

  }

  import(){

    const modalRef = this.modalService.open(ImportModalComponent, {
      size: 'sm',
      windowClass: 'modal-xl',
    });

    const modalInstance = <ImportModalComponent>modalRef.componentInstance;

    modalInstance.isCustom = this.isCustom;
    modalInstance.codOrganization = this.codOrganization;
    modalInstance.codSuscription = this.codSubscription;
    modalInstance.codChannel = this.codChannel;

  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/resources/listado.resources.component.ts